import { render, staticRenderFns } from "./AddressesList.vue?vue&type=template&id=5241b066&scoped=true"
import script from "./AddressesList.ts?vue&type=script&lang=ts&external"
export * from "./AddressesList.ts?vue&type=script&lang=ts&external"
import style0 from "./AddressesList.vue?vue&type=style&index=0&id=5241b066&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241b066",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5241b066')) {
      api.createRecord('5241b066', component.options)
    } else {
      api.reload('5241b066', component.options)
    }
    module.hot.accept("./AddressesList.vue?vue&type=template&id=5241b066&scoped=true", function () {
      api.rerender('5241b066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Addresses/components/AddressesList/AddressesList.vue"
export default component.exports